import Vue from 'vue';
import Vuex from 'vuex';

import localStorage from './localStorage';
import httpClient from './httpClient';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        localStorage,
        httpClient,
    },
});